// src/context/UserContext.js

import React, { createContext, useState, useEffect } from 'react';
import axiosInstance from '../components/axiosInstance'; // Ensure this path is correct
import { useNavigate } from 'react-router-dom';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [employeeId, setEmployeeId] = useState(localStorage.getItem('employeeId') || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Set or remove the Authorization header based on token state
  useEffect(() => {
    if (token) {
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axiosInstance.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Function to log out the user
  const logout = () => {
    setToken(null);
    setEmployeeId(null);
    localStorage.removeItem('token');
    localStorage.removeItem('employeeId');
    navigate('/login');
    window.location.reload();
  };

  return (
    <UserContext.Provider value={{
      token,
      setToken,
      employeeId,
      setEmployeeId,
      loading,
      setLoading,
      error,
      setError,
      logout,
    }}>
      {children}
    </UserContext.Provider>
  );
};